import { queryOptions, useQueryClient } from '@tanstack/react-query'
import { DownloadAttachment, ProblemDetail, ResultSet } from '../../types/types'
import { FetchError, FileIcon, Mtds, useAuth, useErrorToast } from '../..'

type AttachmentsSectionProps = {
  resultSet: ResultSet
  isPositive?: boolean
}

export const AttachmentsSection = ({
  resultSet,
  isPositive
}: AttachmentsSectionProps) => {
  const queryClient = useQueryClient()
  const auth = useAuth()
  const showError = useErrorToast('laste ned vedlegget')
  const attachments = resultSet.attachments || []
  return (
    <>
      {attachments.map((attachment) => (
        <Mtds.Card
          key={attachment.id}
          as={'button'}
          data-color={isPositive ? 'danger' : 'neutral'}
          className='w-full overflow-hidden'
          onClick={async () => {
            const attachmentDownloadLink = attachment.downloadLink
            await queryClient
              .fetchQuery(
                queryOptions({
                  queryKey: [
                    'attachmentDownloadLink',
                    attachmentDownloadLink,
                    'download'
                  ],
                  queryFn: async () => {
                    const { data, error } = await auth
                      .authFetch()
                      .GET(attachmentDownloadLink as never)
                    if (error) {
                      const problem = error as ProblemDetail
                      throw new FetchError(
                        problem?.detail || problem?.title || 'Nedlastingsfeil',
                        problem?.status,
                        problem?.detail
                      )
                    }
                    return data as DownloadAttachment
                  }
                })
              )
              .then((response) => {
                window.open(response.url, '_blank_')
              })
              .catch((error) => {
                showError(error)
              })
          }}
        >
          <Mtds.Flex
            data-align='center'
            data-gap={2}
            data-nowrap
            className='min-w-0 overflow-hidden'
          >
            <FileIcon className='shrink-0' />
            <span className='truncate'>{attachment.filename}</span>
          </Mtds.Flex>
        </Mtds.Card>
      ))}
    </>
  )
}
